export class AppConfig {
    public static API_ENDPOINT = '/index.php/api';
}
